__turbopack_context__.v({
  "card": "style-module-scss-module__mR5qPa__card",
});
